import React, { useState } from "react";
import QuadControlLogo from "../images/headerImages/quad-control-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faE, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import apiConfig from "../utils/allApi";
import ApiCall from "../utils/apiCall";
import "../css/login.css";
const Login = () => {
  const [loginObj, setLoginObj] = useState({});
  const [passwordView, setPasswordView] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  const [mfaStep, setMfaStep] = useState(false);
  const [mfaPendingToken, setMfaPendingToken] = useState("");
  const [mfaCode, setMfaCode] = useState("");
  const [mfaVerifying, setMfaVerifying] = useState(false);
  const [firstLoginStep, setFirstLoginStep] = useState(false);
  const [onboardingToken, setOnboardingToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [settingPassword, setSettingPassword] = useState(false);
  const navigate = useNavigate();
  const { setLoginUser } = useAuth();
  const loginUrl = apiConfig.api_loginurl;
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setLoginObj((prevData) => ({ ...prevData, [name]: value }));
  };

  const completeLogin = (userData) => {
    localStorage.removeItem("encryptData");
    localStorage.setItem("token", userData?.access_token);
    localStorage.setItem("fullName", userData?.fullname);
    localStorage.setItem("userRole", userData?.role);
    localStorage.setItem("loginEmail", userData?.email);
    setLoginUser(userData);
    if (userData?.role == "purchase") {
      navigate("/purchase-dashboard");
    } else if (
      userData?.role === "user" ||
      userData?.role == "operator" ||
      userData?.role === "developer"
    ) {
      navigate("/user-dashboard");
    } else if (userData?.role === "superadmin") {
      navigate("/super-admin/dashboard");
    } else {
      navigate("/admin-dashboard");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg({});
    try {
      const loginRes = await ApiCall.post(loginUrl, loginObj);
      if (loginRes && loginRes?.data?.status == "Success") {
        if (loginRes.data?.first_login) {
          setOnboardingToken(loginRes.data?.onboarding_token);
          setFirstLoginStep(true);
          return;
        }
        if (loginRes.data?.mfa_required) {
          setMfaPendingToken(loginRes.data?.mfa_pending_token);
          setMfaStep(true);
          return;
        }
        const userData = loginRes.data?.data || {};
        setErrorMsg({ status: "Success", message: "User login successfully" });
        completeLogin(userData);
      } else {
        if (loginRes) {
          const handleText = loginRes.data.message
            ? loginRes.data.message
            : "Invalid credentils";
          setErrorMsg({ status: "Failed", message: handleText });
        } else {
          const handleText = loginRes.data.message
            ? loginRes.data.message
            : "Invalid credentils";
          setErrorMsg({ status: "Failed", message: handleText });
        }
      }
    } catch (error) {
      // Never log the raw error here — error.config.data carries the exact
      // request body we just posted (username + password in plaintext).
      setErrorMsg({
        status: "Failed",
        message: "Invalid username and password",
      });
    }
  };

  const handleMfaVerify = async (e) => {
    e.preventDefault();
    setErrorMsg({});
    setMfaVerifying(true);
    try {
      const verifyRes = await ApiCall.post(apiConfig.api_verifyMfaLogin, {
        code: mfaCode,
        mfa_pending_token: mfaPendingToken,
      });
      if (verifyRes && verifyRes?.data?.status == "Success") {
        completeLogin(verifyRes.data?.data || {});
      } else {
        const handleText = verifyRes?.data?.message || "Invalid or expired code";
        setErrorMsg({ status: "Failed", message: handleText });
      }
    } catch (error) {
      setErrorMsg({
        status: "Failed",
        message: "Invalid or expired code",
      });
    } finally {
      setMfaVerifying(false);
    }
  };

  const handleSetPassword = async (e) => {
    e.preventDefault();
    setErrorMsg({});
    if (newPassword !== confirmNewPassword) {
      setErrorMsg({ status: "Failed", message: "Passwords do not match" });
      return;
    }
    setSettingPassword(true);
    try {
      const res = await ApiCall.post(apiConfig.api_firstLoginSetPassword, {
        onboarding_token: onboardingToken,
        new_password: newPassword,
      });
      if (res && res?.data?.status == "Success") {
        navigate("/first-login/mfa-setup", {
          state: {
            onboardingToken: res.data?.onboarding_token,
            email: loginObj.email,
          },
        });
      } else {
        setErrorMsg({
          status: "Failed",
          message: res?.data?.message || "Failed to set password",
        });
      }
    } catch (error) {
      setErrorMsg({
        status: "Failed",
        message:
          error?.response?.data?.message || "Failed to set password",
      });
    } finally {
      setSettingPassword(false);
    }
  };
  return (
    <>
      <div
        className="horizontal-layout horizontal-menu blank-page navbar-floating footer-static  "
        data-open="hover"
        data-menu="horizontal-menu"
        data-col="blank-page"
      >
        <div className="app-content content ">
          <div className="content-overlay"></div>
          <div className="header-navbar-shadow"></div>
          <div className="content-wrapper">
            <div className="content-header row"></div>
            <div className="content-body">
              <div className="auth-wrapper auth-basic px-2">
                <div className="auth-inner my-2">
                  <div className="card mb-0">
                    <div className="card-body">
                      <a href="/" className="brand-logo mb-0">
                        <img src={QuadControlLogo} height={80} width={80} alt="QuadControl" />
                      </a>

                      <h4 className="card-title mb-1 text-center">
                        Welcome to QuadControl
                      </h4>
                      <p className="card-text mb-2">
                        {firstLoginStep
                          ? "Set a new password for your account"
                          : mfaStep
                            ? "Enter the 6-digit code from your authenticator app"
                            : "Please sign-in to your account and start the adventure"}
                      </p>
                      {/* <div className={`${errorMsg.status =="Failed" ? 'text-danger' : 'd-none'}`}>
                                   <span>{errorMsg.message}</span>
                                </div> */}
                      {firstLoginStep ? (
                      <form
                        className="auth-login-form mt-2"
                        onSubmit={handleSetPassword}
                      >
                        <div className="mb-1">
                          <label htmlFor="new-password" className="form-label">
                            New Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="new-password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            aria-describedby="new-password"
                            autoFocus
                            required
                          />
                        </div>
                        <div className="mb-1">
                          <label
                            htmlFor="confirm-new-password"
                            className="form-label"
                          >
                            Confirm New Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="confirm-new-password"
                            value={confirmNewPassword}
                            onChange={(e) =>
                              setConfirmNewPassword(e.target.value)
                            }
                            aria-describedby="confirm-new-password"
                            required
                          />
                        </div>
                        <button
                          className="btn btn-primary w-100"
                          type="submit"
                          disabled={settingPassword}
                        >
                          {settingPassword ? "Saving..." : "Set Password"}
                        </button>
                        {errorMsg.message && (
                          <div
                            id="loginMessage"
                            className={`my-1 ${errorMsg.status === "Failed" ? "unauthorizedUser" : "authorizedUser"}`}
                          >
                            {errorMsg.message}
                          </div>
                        )}
                      </form>
                      ) : !mfaStep ? (
                      <form
                        className="auth-login-form mt-2"
                        onSubmit={handleSubmit}
                      >
                        <div className="mb-1">
                          <label htmlFor="login-email" className="form-label">
                            Email
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={onChangeHandler}
                            id="login-email"
                            name="email"
                            placeholder="john@example.com"
                            aria-describedby="login-email"
                            tabIndex="1"
                            autoFocus
                            required
                          />
                        </div>

                        <div className="mb-1">
                          <div className="d-flex justify-content-between">
                            <label className="form-label" htmlFor="login-password">
                              Password
                            </label>
                            {/* <a href="auth-forgot-password-basic.html">
                                                <small>Forgot Password?</small>
                                            </a> */}
                          </div>
                          <div className="input-group input-group-merge form-password-toggle">
                            <input
                              type={passwordView ? "text" : "password"}
                              className="form-control form-control-merge"
                              onChange={onChangeHandler}
                              id="login-password"
                              name="password"
                              tabIndex="2"
                              placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                              aria-describedby="login-password"
                              required
                            />
                            <span className="input-group-text cursor-pointer">
                              <FontAwesomeIcon
                                size="md"
                                icon={passwordView ? faEyeSlash : faEye}
                                onClick={() => setPasswordView(!passwordView)}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="mb-1">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="remember-me"
                              tabIndex="3"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="remember-me"
                            >
                              {" "}
                              Remember Me{" "}
                            </label>
                          </div>
                        </div>
                        <button
                          className="btn btn-primary w-100"
                          type="submit"
                          tabIndex="4"
                        >
                          Sign in
                        </button>
                        {errorMsg.message && (
                          <div
                            id="loginMessage"
                            className={`my-1 ${errorMsg.status === "Failed" ? "unauthorizedUser" : "authorizedUser"}`}
                          >
                            {errorMsg.message}
                          </div>
                        )}
                        <p className="text-center mt-2 mb-0">
                          <span>First time signing in? </span>
                          <Link to="/first-login-guide">
                            View the setup guide
                          </Link>
                        </p>
                      </form>
                      ) : (
                      <form
                        className="auth-login-form mt-2"
                        onSubmit={handleMfaVerify}
                      >
                        <div className="mb-1">
                          <label htmlFor="mfa-code" className="form-label">
                            Authentication Code
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="mfa-code"
                            name="mfaCode"
                            placeholder="123456"
                            maxLength={6}
                            value={mfaCode}
                            onChange={(e) =>
                              setMfaCode(e.target.value.replace(/\D/g, ""))
                            }
                            aria-describedby="mfa-code"
                            autoFocus
                            required
                          />
                        </div>
                        <button
                          className="btn btn-primary w-100"
                          type="submit"
                          disabled={mfaVerifying || mfaCode.length !== 6}
                        >
                          {mfaVerifying ? "Verifying..." : "Verify"}
                        </button>
                        {errorMsg.message && (
                          <div
                            id="loginMessage"
                            className={`my-1 ${errorMsg.status === "Failed" ? "unauthorizedUser" : "authorizedUser"}`}
                          >
                            {errorMsg.message}
                          </div>
                        )}
                      </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
